import { TYPOGRAPHY_FONT_FAMILY_NAMES } from './typographyFontFamily';
import { TYPOGRAPHY_STYLES_MAP } from './TypographyType';

export const createAIDTTypography = (
  fontFamily: keyof typeof TYPOGRAPHY_FONT_FAMILY_NAMES,
  typographyType?: keyof typeof TYPOGRAPHY_STYLES_MAP
) => ({
  fontFamily:
    TYPOGRAPHY_FONT_FAMILY_NAMES[fontFamily] ||
    TYPOGRAPHY_FONT_FAMILY_NAMES['pretendard'],
  '@font-face': [
    {
      fontFamily: 'Pretendard',
      fontStyle: 'normal',
      fontWeight: 900,
      fontDisplay: 'swap',
      src: `url('https://cdnjs.cloudflare.com/ajax/libs/pretendard/1.3.9/static/pretendard.css') format('woff2')`,
    },
    {
      fontFamily: 'Pretendard',
      fontStyle: 'normal',
      fontWeight: 700,
      fontDisplay: 'swap',
      src: `url('https://cdnjs.cloudflare.com/ajax/libs/pretendard/1.3.9/static/Pretendard-ExtraBold.min.css') format('woff2')`,
    },
    {
      fontFamily: 'Pretendard',
      fontStyle: 'normal',
      fontWeight: 500,
      fontDisplay: 'swap',
      src: `url('https://cdnjs.cloudflare.com/ajax/libs/pretendard/1.3.9/static/Pretendard-Medium.min.css') format('woff2')`,
    },
    {
      fontFamily: 'EliceDXNeolli',
      fontStyle: 'normal',
      fontWeight: 900,
      fontDisplay: 'swap',
      src: `url(https://cdn.jsdelivr.net/gh/fonts-archive/EliceDXNeolli/EliceDXNeolli-Bold.woff2) format('woff2')`,
    },
    {
      fontFamily: 'EliceDXNeolli',
      fontStyle: 'normal',
      fontWeight: 700,
      fontDisplay: 'swap',
      src: `url(https://cdn.jsdelivr.net/gh/fonts-archive/EliceDXNeolli/EliceDXNeolli-Bold.woff2) format('woff2')`,
    },
    {
      fontFamily: 'EliceDXNeolli',
      fontStyle: 'normal',
      fontWeight: 500,
      fontDisplay: 'swap',
      src: `url(https://cdn.jsdelivr.net/gh/fonts-archive/EliceDXNeolli/EliceDXNeolli-Medium.woff2) format('woff2')`,
    },
  ],
  ...(TYPOGRAPHY_STYLES_MAP[typographyType ?? 'Default']),
});
